import Vue from "vue";
import Component from "vue-class-component";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";

@Component
export default class PaymentPackageMixin extends Vue {
  @CheckAuthorities("PaymentPackages", "update_any")
  public allowEdit!: boolean;
}
